import { HStack, Text, VStack } from 'ui_2';
import curvedTicket from '../../public/assets/curved_ticket.svg';

type Props = {
  round: number;
  rounds: number;
  score: number;
};

export const RoundsAndScore = ({ round, rounds, score }: Props) => {
  return (
    <VStack className='w-[100px] rounded-lg bg-black px-[10px] py-1 text-base sm:text-lg lg:text-xl'>
      <div className='flex justify-end opacity-80'>
        <Text family='space' font='xs' className='text-aqua'>
          {round + 1} of {rounds}
        </Text>
      </div>
      <HStack className='items-center justify-between'>
        <img src={curvedTicket} width={20} />
        <Text family='space' font='md' className='text-aqua'>
          {score}
        </Text>
      </HStack>
    </VStack>
  );
};
